const fetchCheck = async (
  year,
  make,
  model,
  trim,
  color,
  seat,
  cabSize = "",
) => {
  if (!year) return [];
  if (!make) return [];
  if (!model) return [];

  let wtype = "normal";
  if (window?.is_real_truck) {
    wtype = "realtruck";
  } else if (window?.scs_force_custom) {
    wtype = "custom";
  } else if (window?.scs_custom_endpoint) {
    wtype = "realtruck";
  }

  const params = {
    year: year,
    make: make,
    model: model,
    colorCode: color || "Black",
    wtype: wtype,
  };
  if (trim && trim !== "") {
    params["trim"] = trim;
  }
  if (cabSize && cabSize !== "") {
    params["cab"] = cabSize;
  }

  if (seat) {
    params["type"] = seat;
  }
  if (window.scs_page_seo === true) {
    params["page_seo"] = "1";
  }

  const urlMakes = "https://scsbiz.wearevisum.com/api/v1/check";
  const response = await fetch(urlMakes, {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  }).catch((error) => console.log("error", error));

  const resp = await response?.json();
  resp.data.compatibility_custom = resp.data.custom_compatibility;
  // console.log('check resp', resp)

  if (resp.data.compatibility === "HF") {
    resp.data.compatibility = "F";
  }
  if (
    resp.data.compatibility === "N" ||
    resp.data.compatibility === "DNE" ||
    resp.data.compatibility === "NAON"
  ) {
    resp.data.compatibility = "N";
  }

  if (window.scs_force_normal === true) {
    resp.data.custom_compatibility = "N";
    resp.data.compatibility_custom = "N";
  } else {
    if (window.scs_force_custom === true) {
      resp.data.compatibility = "N";
    }
  }

  resp.data.custom_compatibility = resp.data.compatibility_custom;

  // console.log('check resp 2:', resp)

  return resp.data;
};

export default fetchCheck;
